/**
 * Central links registry for Pharmacy First pathways.
 * Keys are namespaced identifiers used by pathway files (e.g. "nice-cks-shingles").
 */

export const links: Record<string, any> = {
  "nice-cks-shingles": {
    label: "NICE CKS — Shingles",
    url: "https://cks.nice.org.uk/topics/shingles/",
    audience: "clinician",
    type: "web",
  },

  "nhs-shingles": {
    label: "NHS — Shingles",
    url: "https://www.nhs.uk/conditions/shingles/",
    audience: "patient",
    type: "web",
  },

  "bad-shingles-leaflet": {
    label: "British Association of Dermatologists — Shingles patient leaflet",
    url: "https://www.bad.org.uk/pils/shingles/",
    audience: "patient",
    type: "leaflet",
  },

  "nice-cks-otitis-media": {
    label: "NICE CKS — Otitis media (acute)",
    url: "https://cks.nice.org.uk/topics/otitis-media-acute/",
    audience: "clinician",
    type: "web",
  },

  "healthier-together-earache": {
    label: "Healthier Together — Otitis media (earache)",
    url: "https://www.what0-18.nhs.uk/parentscarers/worried-your-child-unwell/earache",
    audience: "clinician",
    type: "web",
  },

  "target-rti-leaflet": {
    label: "TARGET RTI patient information leaflet",
    url: "https://elearning.rcgp.org.uk/mod/book/view.php?id=12647",
    audience: "patient",
    type: "leaflet",
  },

  "nhs-ear-infection": {
    label: "NHS — Ear infections",
    url: "https://www.nhs.uk/conditions/ear-infections/",
    audience: "patient",
    type: "web",
  },

  "crediblemeds-qt": {
    label: "CredibleMeds — QT drug list",
    url: "https://crediblemeds.org/",
    audience: "clinician",
    type: "tool",
    note: "Registration required",
  },

  "sads-drugs-avoid": {
    label: "SADS — Drugs to avoid",
    url: "https://www.sads.org.uk/drugs-to-avoid/",
    audience: "clinician",
    type: "tool",
  },

  "indiana-flockhart": {
    label: "Indiana University — Drug Interactions Flockhart Table",
    url: "https://drug-interactions.medicine.iu.edu/MainTable.aspx",
    audience: "clinician",
    type: "tool",
  },

  "feverpain-tool": {
    label: "FeverPAIN Score for Strep Pharyngitis",
    url: "https://www.mdcalc.com/calc/10076/feverpain-score-strep-pharyngitis",
    audience: "clinician",
    type: "tool",
  },

  "medicines-for-children-amoxicillin": {
    label: "Medicines for Children — Amoxicillin",
    url: "https://www.medicinesforchildren.org.uk/medicines/amoxicillin-for-bacterial-infections/",
    audience: "clinician",
    type: "web",
  },

  "medicines-for-children-fluclox": {
    label: "Medicines for Children — Flucloxacillin",
    url: "https://www.medicinesforchildren.org.uk/medicines/flucloxacillin-for-bacterial-infections/",
    audience: "clinician",
    type: "web",
  },

  "medicines-for-children-clari": {
    label: "Medicines for Children — Clarithromycin",
    url: "https://www.medicinesforchildren.org.uk/medicines/clarithromycin-for-bacterial-infections/",
    audience: "clinician",
    type: "web",
  },

  "medicines-for-children-giving-tablets": {
    label: "Medicines for Children — Giving tablets",
    url: "https://www.medicinesforchildren.org.uk/giving-medicines/giving-tablets/",
    audience: "clinician",
    type: "web",
  },

  "medicines-for-children-giving-capsules": {
    label: "Medicines for Children — Giving capsules",
    url: "https://www.medicinesforchildren.org.uk/giving-medicines/giving-capsules/",
    audience: "clinician",
    type: "web",
  },

  "nice-cks-insect-bites": {
    label: "NICE CKS — Insect Bites and Stings",
    url: "https://cks.nice.org.uk/topics/insect-bites-stings/",
    audience: "clinician",
    type: "web",
  },

  "nice-cks-cellulitis": {
    label: "NICE CKS — Acute Cellulitis",
    url: "https://cks.nice.org.uk/topics/cellulitis-acute/",
    audience: "clinician",
    type: "web",
  },

  "nice-lyme-rash-images": {
    label: "NICE — Lyme disease rash images",
    url: "https://cks.nice.org.uk/topics/lyme-disease/",
    audience: "clinician",
    type: "web",
  },

  "nhs-insect-bites": {
    label: "NHS — Insect bites and stings",
    url: "https://www.nhs.uk/conditions/insect-bites-and-stings/",
    audience: "patient",
    type: "web",
  },

  "ukhsa-tick-awareness": {
    label: "UKHSA — Tick Awareness",
    url: "https://www.gov.uk/guidance/tick-awareness",
    audience: "patient",
    type: "web",
  },

  "anaphylaxis-campaign": {
    label: "The Anaphylaxis Campaign — Insect sting allergy",
    url: "https://www.anaphylaxis.org.uk/knowledgebase/insect-sting-allergy-the-facts/",
    audience: "patient",
    type: "web",
  },

  "target-selfcare-leaflet": {
    label: "TARGET self-care leaflet",
    url: "https://elearning.rcgp.org.uk/mod/book/view.php?id=12647",
    audience: "patient",
    type: "leaflet",
  },

  "nice-cks-impetigo": {
    label: "NICE CKS — Impetigo",
    url: "https://cks.nice.org.uk/topics/impetigo/",
    audience: "clinician",
    type: "web",
  },

  "nice-ng153-impetigo": {
    label: "NICE NG153 — Impetigo: antimicrobial prescribing",
    url: "https://www.nice.org.uk/guidance/ng153",
    audience: "clinician",
    type: "web",
  },

  "bad-impetigo-leaflet": {
    label: "British Association of Dermatologists — Impetigo patient leaflet",
    url: "https://www.bad.org.uk/pils/impetigo/",
    audience: "patient",
    type: "leaflet",
  },

  "nhs-impetigo": {
    label: "NHS — Impetigo images and advice",
    url: "https://www.nhs.uk/conditions/impetigo/",
    audience: "patient",
    type: "web",
  },

  "nice-cks-sinusitis": {
    label: "NICE CKS — Sinusitis",
    url: "https://cks.nice.org.uk/topics/sinusitis/",
    audience: "clinician",
    type: "web",
  },

  "nhs-sinusitis": {
    label: "NHS — Sinusitis",
    url: "https://www.nhs.uk/conditions/sinusitis-sinus-infection/",
    audience: "patient",
    type: "web",
  },

  "nice-cks-sore-throat": {
    label: "NICE CKS — Sore throat (acute)",
    url: "https://cks.nice.org.uk/topics/sore-throat-acute/",
    audience: "clinician",
    type: "web",
  },

  "healthier-together-tonsillitis": {
    label: "Healthier Together — Tonsillitis / sore throat (children)",
    url: "https://www.what0-18.nhs.uk/parentscarers/worried-your-child-unwell/sore-throat-tonsillitis",
    audience: "clinician",
    type: "web",
  },

  "nhs-sore-throat": {
    label: "NHS — Sore throat",
    url: "https://www.nhs.uk/conditions/sore-throat/",
    audience: "patient",
    type: "web",
  },

  "nice-cks-scarlet-fever": {
    label: "NICE CKS — Scarlet fever",
    url: "https://cks.nice.org.uk/topics/scarlet-fever/",
    audience: "clinician",
    type: "web",
  },

  "nice-cks-glandular-fever": {
    label: "NICE CKS — Glandular fever",
    url: "https://cks.nice.org.uk/topics/glandular-fever/",
    audience: "clinician",
    type: "web",
  },

  "medicines-for-children-penv": {
    label: "Medicines for Children — Phenoxymethylpenicillin",
    url: "https://www.medicinesforchildren.org.uk/medicines/phenoxymethylpenicillin-for-bacterial-infections/",
    audience: "clinician",
    type: "web",
  },

  "nice-cks-uti-lower": {
    label: "NICE CKS — Lower Urinary tract infection in Women",
    url: "https://cks.nice.org.uk/topics/urinary-tract-infection-lower-women/",
    audience: "clinician",
    type: "web",
  },

  "nice-cks-pyelonephritis": {
    label: "NICE CKS — Pyelonephritis",
    url: "https://cks.nice.org.uk/topics/pyelonephritis-acute/",
    audience: "clinician",
    type: "web",
  },

  "nice-cks-feverpain-clinical-features": {
    label: "NICE CKS — FeverPAIN clinical features",
    url: "https://cks.nice.org.uk/topics/sore-throat-acute/diagnosis/clinical-features/",
    audience: "clinician",
    type: "web",
  },

  "shingles-image-1": {
    label: "Shingles clinical image 1",
    url: "https://cdn.builder.io/api/v1/image/assets%2F0407d02f319145f582bec36d8e4031e2%2F66e9acbbe61f48378f262ed3b4866728",
    audience: "clinician",
    type: "image",
  },

  "shingles-image-2": {
    label: "Shingles clinical image 2",
    url: "https://cdn.builder.io/api/v1/image/assets%2F0407d02f319145f582bec36d8e4031e2%2Faf6a031c9d134d4583f1acbcd2097b43",
    audience: "clinician",
    type: "image",
  },

  "shingles-image-3": {
    label: "Shingles clinical image 3",
    url: "https://cdn.builder.io/api/v1/image/assets%2F0407d02f319145f582bec36d8e4031e2%2F53a23e8c53254b84b5050f84280439ae",
    audience: "clinician",
    type: "image",
  },

  "shingles-image-4": {
    label: "Shingles clinical image 4",
    url: "https://cdn.builder.io/api/v1/image/assets%2F0407d02f319145f582bec36d8e4031e2%2F24788ab992ef44ed8d44c99b46063fb3",
    audience: "clinician",
    type: "image",
  },

  "insectbites-image-1": {
    label: "Insect bites clinical image 1",
    url: "https://cdn.builder.io/api/v1/image/assets%2F0407d02f319145f582bec36d8e4031e2%2Facbcf2f043254fa788cad2896aba8f9c",
    audience: "clinician",
    type: "image",
  },

  "insectbites-image-2": {
    label: "Insect bites clinical image 2",
    url: "https://cdn.builder.io/api/v1/image/assets%2F0407d02f319145f582bec36d8e4031e2%2Fd059050be9fb4a40a2293d24a748c0be",
    audience: "clinician",
    type: "image",
  },

  "insectbites-image-3": {
    label: "Insect bites clinical image 3",
    url: "https://cdn.builder.io/api/v1/image/assets%2F0407d02f319145f582bec36d8e4031e2%2F0e2ca2bc210346989923123c25bf6003",
    audience: "clinician",
    type: "image",
  },

  "nhs-england-pharmacy-first-service-spec": {
    label:
      "NHS England — Community Pharmacy Advanced Service Specification: NHS Pharmacy First Service",
    url: "https://www.england.nhs.uk/wp-content/uploads/2023/11/PRN00936-i-Community-pharmacy-advanced-service-specification-NHS-pharmacy-first-service-November-2023.pdf",
    audience: "clinician",
    type: "leaflet",
  },

  "nhs-england-pharmacy-first-clinical-pathways": {
    label: "NHS Pharmacy First — Clinical Pathways (v2.5)",
    url: "https://www.england.nhs.uk/wp-content/uploads/2023/11/PRN00936_ii_pharmacy-first-clinical-pathways-version-2.5.pdf",
    audience: "clinician",
    type: "leaflet",
  },

  "pgd-uti-nitrofurantoin": {
    label: "PGD 1a — Nitrofurantoin for urinary tract infection",
    url: "https://www.england.nhs.uk/wp-content/uploads/2023/11/PRN01010-1a.-urinary-tract-infection-nitrofurantoin-patient-group-direction-pharmacy-first.pdf",
    audience: "clinician",
    type: "leaflet",
  },

  "pgd-shingles-aciclovir": {
    label: "PGD 2a — Aciclovir for shingles",
    url: "https://www.england.nhs.uk/wp-content/uploads/2023/11/PRN01010-2a.-shingles-aciclovir-patient-group-direction-pharmacy-first.pdf",
    audience: "clinician",
    type: "leaflet",
  },

  "pgd-shingles-valaciclovir": {
    label: "PGD 2b — Valaciclovir for shingles",
    url: "https://www.england.nhs.uk/wp-content/uploads/2023/11/PRN01010-2b.-shingles-valaciclovir-patient-group-direction-pharmacy-first.pdf",
    audience: "clinician",
    type: "leaflet",
  },

  "pgd-impetigo-hydrogen-peroxide": {
    label:
      "PGD 3a — Topical hydrogen peroxide 1% cream for localised non-bullous impetigo",
    url: "https://www.england.nhs.uk/wp-content/uploads/2023/11/PRN01010-3a.-impetigo-hydrogen-peroxide-cream-protocol-pharmacy-first.pdf",
    audience: "clinician",
    type: "leaflet",
  },

  "pgd-impetigo-fusidic-acid": {
    label: "PGD 3b — Fusidic acid cream for localised non-bullous impetigo",
    url: "https://www.england.nhs.uk/wp-content/uploads/2023/11/PRN01010-3b.-Impetigo-fusidic-acid-cream-patient-group-direction-Pharmacy-First.pdf",
    audience: "clinician",
    type: "leaflet",
  },

  "pgd-impetigo-flucloxacillin": {
    label: "PGD 3c — Flucloxacillin for widespread non-bullous impetigo",
    url: "https://www.england.nhs.uk/wp-content/uploads/2023/11/PRN01010-3c.-impetigo-flucloxacillin-patient-group-direction-pharmacy-first.pdf",
    audience: "clinician",
    type: "leaflet",
  },

  "pgd-impetigo-clarithromycin": {
    label: "PGD 3d — Clarithromycin for widespread non-bullous impetigo",
    url: "https://www.england.nhs.uk/wp-content/uploads/2023/11/PRN01010-3d.-impetigo-clarithromycin-patient-group-direction-pharmacy-first.pdf",
    audience: "clinician",
    type: "leaflet",
  },

  "pgd-impetigo-erythromycin": {
    label:
      "PGD 3e — Erythromycin for widespread non-bullous impetigo (pregnant individuals)",
    url: "https://www.england.nhs.uk/wp-content/uploads/2023/11/PRN01010-3e.-impetigo-erythromycin-patient-group-direction-pharmacy-first.pdf",
    audience: "clinician",
    type: "leaflet",
  },

  "pgd-insect-bites-flucloxacillin": {
    label: "PGD 4a — Flucloxacillin for infected insect bites and stings",
    url: "https://www.england.nhs.uk/wp-content/uploads/2023/11/PRN01010-4a.-infected-insect-bites-flucloxacillin-patient-group-direction-pharmacy-first.pdf",
    audience: "clinician",
    type: "leaflet",
  },

  "pgd-insect-bites-clarithromycin": {
    label: "PGD 4b — Clarithromycin for infected insect bites and stings",
    url: "https://www.england.nhs.uk/wp-content/uploads/2023/11/PRN01010-4b.-infected-insect-bites-clarithromycin-patient-group-direction-pharmacy-first.pdf",
    audience: "clinician",
    type: "leaflet",
  },

  "pgd-insect-bites-erythromycin": {
    label:
      "PGD 4c — Erythromycin for infected insect bites (pregnant individuals)",
    url: "https://www.england.nhs.uk/wp-content/uploads/2023/11/PRN01010-4c.-infected-insect-bites-erythromycin-patient-group-direction-pharmacy-first.pdf",
    audience: "clinician",
    type: "leaflet",
  },

  "pgd-sore-throat-phenoxymethylpenicillin": {
    label: "PGD 5a — Phenoxymethylpenicillin for acute sore throat",
    url: "https://www.england.nhs.uk/wp-content/uploads/2023/11/PRN01010-5a.-sore-throat-phenoxymethylpenicillin-patient-group-direction-pharmacy-first.pdf",
    audience: "clinician",
    type: "leaflet",
  },

  "pgd-sore-throat-clarithromycin": {
    label: "PGD 5b — Clarithromycin for acute sore throat",
    url: "https://www.england.nhs.uk/wp-content/uploads/2023/11/PRN01010-5b.-sore-throat-clarithromycin-patient-group-direction-pharmacy-first.pdf",
    audience: "clinician",
    type: "leaflet",
  },

  "pgd-sore-throat-erythromycin": {
    label: "PGD 5c — Erythromycin for acute sore throat (pregnant individuals)",
    url: "https://www.england.nhs.uk/wp-content/uploads/2023/11/PRN01010-5c.-sore-throat-erythromycin-patient-group-direction-pharmacy-first.pdf",
    audience: "clinician",
    type: "leaflet",
  },

  "pgd-sinusitis-fluticasone": {
    label: "PGD 6a — Fluticasone furoate nasal spray for acute sinusitis",
    url: "https://www.england.nhs.uk/wp-content/uploads/2023/11/PRN01010-6a.-sinusitis-fluticasone-nasal-spray-patient-group-direction-pharmacy-first.pdf",
    audience: "clinician",
    type: "leaflet",
  },

  "pgd-sinusitis-mometasone": {
    label: "PGD 6b — Mometasone furoate nasal spray for acute sinusitis",
    url: "https://www.england.nhs.uk/wp-content/uploads/2023/11/PRN01010-6b.-sinusitis-mometasone-nasal-spray-patient-group-direction-pharmacy-first.pdf",
    audience: "clinician",
    type: "leaflet",
  },

  "pgd-sinusitis-phenoxymethylpenicillin": {
    label: "PGD 6c — Phenoxymethylpenicillin for acute bacterial sinusitis",
    url: "https://www.england.nhs.uk/wp-content/uploads/2023/11/PRN01010-6c.-sinusitis-phenoxymethylpenicillin-patient-group-direction-pharmacy-first.pdf",
    audience: "clinician",
    type: "leaflet",
  },

  "pgd-sinusitis-clarithromycin": {
    label: "PGD 6d — Clarithromycin for acute bacterial sinusitis",
    url: "https://www.england.nhs.uk/wp-content/uploads/2023/11/PRN01010-6d.-sinusitis-clarithromycin-patient-group-direction-pharmacy-first.pdf",
    audience: "clinician",
    type: "leaflet",
  },

  "pgd-sinusitis-doxycycline": {
    label: "PGD 6e — Doxycycline for acute bacterial sinusitis",
    url: "https://www.england.nhs.uk/wp-content/uploads/2023/11/PRN01010-6e.-sinusitis-doxycycline-patient-group-direction-pharmacy-first.pdf",
    audience: "clinician",
    type: "leaflet",
  },

  "pgd-sinusitis-erythromycin": {
    label:
      "PGD 6f — Erythromycin for acute bacterial sinusitis (pregnant individuals)",
    url: "https://www.england.nhs.uk/wp-content/uploads/2023/11/PRN01010-6f.-sinusitis-erythromycin-patient-group-direction-pharmacy-first.pdf",
    audience: "clinician",
    type: "leaflet",
  },

  "pgd-otitis-media-otigo": {
    label:
      "PGD 7a — Otigo® ear drops (phenazone/lidocaine) for acute otitis media",
    url: "https://www.england.nhs.uk/wp-content/uploads/2023/11/PRN01010-7a.-acute-otitis-media-phenazone-lidocaine-ear-drops-patient-group-direction-pharmacy-first.pdf",
    audience: "clinician",
    type: "leaflet",
  },

  "pgd-otitis-media-amoxicillin": {
    label: "PGD 7b — Amoxicillin for acute otitis media",
    url: "https://www.england.nhs.uk/wp-content/uploads/2023/11/PRN01010-7b.-acute-otitis-media-amoxicillin-patient-group-direction-pharmacy-first.pdf",
    audience: "clinician",
    type: "leaflet",
  },

  "pgd-otitis-media-clarithromycin": {
    label: "PGD 7c — Clarithromycin for acute otitis media",
    url: "https://www.england.nhs.uk/wp-content/uploads/2023/11/PRN01010-7c.-acute-otitis-media-clarithromycin-patient-group-direction-pharmacy-first.pdf",
    audience: "clinician",
    type: "leaflet",
  },

  "pgd-otitis-media-erythromycin": {
    label:
      "PGD 7d — Erythromycin for acute otitis media (pregnant individuals)",
    url: "https://www.england.nhs.uk/wp-content/uploads/2023/11/PRN01010-7d.-acute-otitis-media-erythromycin-patient-group-direction-pharmacy-first.pdf",
    audience: "clinician",
    type: "leaflet",
  },

  // Hypertension links
  "nice-ng136-bp": {
    label: "NICE NG136 — Blood Pressure Management in Adults",
    url: "https://www.nice.org.uk/guidance/ng136",
    audience: "clinician",
    type: "web",
  },

  "nhs-england-htn-case-finding": {
    label: "NHS England — Hypertension Case-Finding Service Specification",
    url: "https://www.england.nhs.uk/wp-content/uploads/2021/11/PRN00948-nhs-community-pharmacy-hypertension-case-finding-advanced-service-v2.3.pdf",
    audience: "clinician",
    type: "leaflet",
  },

  "nhs-htn-info": {
    label: "NHS — What is high blood pressure?",
    url: "https://www.nhs.uk/conditions/high-blood-pressure-hypertension/",
    audience: "patient",
    type: "web",
  },

  "nhs-abpm-guide": {
    label: "NHS — Ambulatory Blood Pressure Monitoring (ABPM)",
    url: "https://www.nhs.uk/conditions/high-blood-pressure-hypertension/",
    audience: "patient",
    type: "web",
  },

  "nhs-home-bp-monitoring": {
    label: "NHS — Home Blood Pressure Monitoring",
    url: "https://www.nhs.uk/conditions/high-blood-pressure-hypertension/",
    audience: "patient",
    type: "web",
  },

  // Contraception links
  "nhs-england-contraception-service": {
    label: "NHS England — Pharmacy Contraception Service",
    url: "https://www.england.nhs.uk/long-read/nhs-pharmacy-contraception-service/",
    audience: "clinician",
    type: "web",
  },

  "nhs-contraception-service-specification": {
    label: "NHS Contraception Service Specification (v3.0)",
    url: "https://www.england.nhs.uk/wp-content/uploads/2023/01/PRN02207_i_community-pharmacy-advanced-service-specification-nhs-pharmacy-contraception-service-v3.0.pdf",
    audience: "clinician",
    type: "leaflet",
  },

  "pgd-emergency-contraception-levonorgestrel": {
    label: "PGD — Levonorgestrel 1.5mg for emergency contraception",
    url: "https://www.england.nhs.uk/wp-content/uploads/2023/01/PRN02207_ii_patient-group-directon-supply-levonorgestrel-1.5mg-tablets-emergency-contraception-v1.0.pdf",
    audience: "clinician",
    type: "leaflet",
  },

  "pgd-emergency-contraception-ulipristal": {
    label: "PGD — Ulipristal acetate 30mg for emergency contraception",
    url: "https://www.england.nhs.uk/wp-content/uploads/2023/01/PRN02207_iii_patient-group-directon-supply-ulipristal-acetate-30mg-tablet-emergency-contraception-v1.0.pdf",
    audience: "clinician",
    type: "leaflet",
  },

  "pgd-combined-oral-contraceptive": {
    label: "PGD — Combined oral hormonal contraceptive (COC)",
    url: "https://www.england.nhs.uk/wp-content/uploads/2023/01/PRN02207_iv_patient-group-directon-supply-combined-oral-hormonal-contraceptive-COC-v3.0.pdf",
    audience: "clinician",
    type: "leaflet",
  },

  "pgd-progestogen-only-pill": {
    label: "PGD — Progestogen-only contraceptive pill (POP)",
    url: "https://www.england.nhs.uk/wp-content/uploads/2023/01/PRN02207_v_patient-group-directon-supply-progestogen-only-contraceptive-pill-pop-v3.0.pdf",
    audience: "clinician",
    type: "leaflet",
  },

  "brook-contraception-chooser": {
    label: "Brook — Find the Best Contraception for You",
    url: "https://www.brook.org.uk/best-contraception-for-me/",
    audience: "patient",
    type: "tool",
  },

  "contraception-choices": {
    label: "Contraception Choices — What's Right for Me",
    url: "https://www.contraceptionchoices.org/whats-right-for-me",
    audience: "patient",
    type: "tool",
  },
};

export const linksRegistry = {
  get: (key: string) => links[key],
  all: () => links,
};
